import { lazy } from "react";

// project imports
import MinimalLayout from "layout/MinimalLayout";
import Loadable from "ui-component/Loadable";

const Login = Loadable(lazy(() => import("views/auth/login")));
const VerifyOTP = Loadable(lazy(() => import("views/auth/verify-otp")));

const AuthRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/verify-otp",
      element: <VerifyOTP />,
    },
  ],
};

export default AuthRoutes;
